import { Typography } from 'material-ui'
import * as React from 'react'
import { SFC } from 'react'

export const ProjectSelectorTitle: SFC<{ title: string, sub: string, small?: boolean }> = ({title, sub, small}) => (
    <div style={{padding: small ? '20px 15px' : '40px 25px'}}>
        <Typography type='title' style={{color: '#fff', margin: 10, fontSize: 16, fontWeight: 100}}>
            {sub}
        </Typography>
        <Typography type='display1' style={{color: '#fff', margin: 10, fontSize: 32}}>
            {title}
        </Typography>
    </div>
)

export const ProjectSelectorCard: SFC<{
    color: string,
    img: string,
    height: number,
    marginBottom?: number,
    onClick: () => void
}> =
    ({color, img, height, onClick, marginBottom, children}) => (
        <div
            onClick={onClick}
            style={{
                background: `${color} url("${img}") no-repeat`,
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                height,
                textAlign: 'left',
                marginBottom: marginBottom || 0,
                cursor: 'pointer',
                width: '100%'
            }}
        >
            {children}
        </div>

    )



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/components/ProjectSelectorCard.tsx